import styled from 'styled-components'
import {semiDarkGray, darkGray} from '@modifi/colors'

export const Label = styled.div`
  color: ${semiDarkGray};
`

export const Value = styled.div`
  color: ${darkGray};
  margin-bottom: 24px;
`
